import { render, staticRenderFns } from "./PageLayoutTwo.vue?vue&type=template&id=445909db&"
import script from "./PageLayoutTwo.vue?vue&type=script&lang=js&"
export * from "./PageLayoutTwo.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutTwo.vue?vue&type=style&index=0&id=445909db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports